import TextButton from 'LuxKit/Button/TextButton'
import { rem } from 'polished'
import { forwardRef } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import CarsAirportTransferInputs from './CarsAirportTransferInputs'
import CarsAirportTransferJourneyTypeSelector from './CarsAirportTransferJourneyTypeSelector'
import useAirportTransferSearchControls from '../hooks/useAirportTransferSearchControls'
import type { CarsAirportTransferSearchFieldHandle } from '../hooks/useAirportTransferSearchPrompt'

const SearchBar = styled.form`
  display: grid;
  gap: ${rem(8)};
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
`

const CarsAirportTransferSearchBar = forwardRef<CarsAirportTransferSearchFieldHandle>(function CarsAirportTransferSearchBar(_, ref) {
  const intl = useIntl()
  const {
    closeJourneyTypeSelection,
    onJourneyTypeSelect,
    onSearch,
    openJourneyTypeSelection,
  } = useAirportTransferSearchControls()

  return (
    <SearchBar onSubmit={onSearch}>
      <CarsAirportTransferJourneyTypeSelector
        onJourneyTypeSelect={onJourneyTypeSelect}
        onJourneyTypeSelectionOpen={openJourneyTypeSelection}
        onJourneyTypeSelectionClose={closeJourneyTypeSelection}
      />
      <CarsAirportTransferInputs ref={ref} />
      <TextButton
        kind="primary"
        size="medium"
        shape="round"
        type="submit"
      >
        {intl.formatMessage({
          id: 'nTLQ0Si91szzhZy_CaN-',
          defaultMessage: 'Search',
          description: 'Submit button for the airport transfer search form',
        })}
      </TextButton>
    </SearchBar>
  )
})

export default CarsAirportTransferSearchBar
